<script>
    import _ from 'lodash'

    export let scope
    export let field
    export let responses = []

    $: outOfScope = !field.scopes.find(s => s === scope)
    $: text = _.join(responses.map(response => response["f" + field.id] || '∅'), ',') 

</script>
<div class="item">
    <div class="right floated content">
        {#if responses.length > 0}
            {text}
        {/if}
    </div>
    <div class="ui label" 
            class:basic={outOfScope}
            class:disabled={outOfScope}>{field.definition}</div>
</div>
